import "./Toggle.scss"

import React, { FunctionComponent, ReactNode } from "react"
import cx from "classnames"
import Spinner from "components/Spinner/Spinner"

interface IToggleProps {
    active?: boolean
    loading?: boolean
    disabled?: boolean
    label?: ReactNode
    flow?: React.CSSProperties["flexFlow"]
    testId?: string
    onToggle?(): void
}

const Toggle: FunctionComponent<React.PropsWithChildren<IToggleProps>> = ({
    active,
    loading,
    disabled,
    label,
    flow,
    testId,
    onToggle
}) => {
    function handleToggle() {
        if (typeof onToggle !== "function") return
        onToggle()
    }

    return (
        <button
            type="button"
            className={cx(["toggle", { "toggle__active": active }])}
            onClick={handleToggle}
            disabled={disabled}
            style={{ flexFlow: flow }}
            data-active={active}
            data-testid={testId || "toggle"}>
            <span className="toggle__body-wrap">
                <span className={cx(["toggle__body", { "toggle__body--loading": loading }])}>
                    {loading &&
                        <Spinner size={16} />
                    }
                </span>
            </span>
            {!!label &&
                <span className="toggle__label">{label}</span>
            }
        </button>
    )
}

export default Toggle
